module.exports = __webpack_public_path__ + "b94b4459f4e6b53ea009062eff210f13.png";